import {
	LOCALSTORAGE_METHODS as LocalStorageMethodEnum,
	localStorageService,
} from "src/general/utils/local-storage.service";
import { AUTH_FIELDS } from "../../../entities/auth.entity/redux/fields";

const logout = () => {
	localStorageService(LocalStorageMethodEnum.REMOVE, {
		key: AUTH_FIELDS.TOKEN_ACCESS,
	});
	localStorageService(LocalStorageMethodEnum.REMOVE, {
		key: AUTH_FIELDS.TOKEN_REFRESH,
	});
	localStorageService(LocalStorageMethodEnum.REMOVE, {
		key: AUTH_FIELDS.IS_NEED_CHANGE,
	});
	localStorageService(LocalStorageMethodEnum.REMOVE, {
		key: AUTH_FIELDS.HAS_REDIRECTED,
	});
};

export default logout;
